import React, { useMemo, useState } from 'react';
import { useAuth } from '../AuthProvider';
import { changeNumber, getApiErrorMessage, resolveCompanyId } from './CallCenterService';
import './CallCenter.css';

export default function ChangeNumberPage() {
  const authContext = useAuth();
  const companyId = useMemo(() => resolveCompanyId(authContext?.additionalUserInfo), [authContext?.additionalUserInfo]);

  const [currentPhoneNumber, setCurrentPhoneNumber] = useState('');
  const [newPhoneNumber, setNewPhoneNumber] = useState('');
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    setSuccess('');

    try {
      const payload = {
        currentPhoneNumber,
        newPhoneNumber,
        reason,
      };

      const result = await changeNumber(authContext.token, companyId, payload);
      const finalNumber = result?.phoneNumber || result?.e164PhoneNumber || newPhoneNumber;
      setSuccess(`Number changed successfully to ${finalNumber}.`);
      setCurrentPhoneNumber('');
      setNewPhoneNumber('');
      setReason('');
    } catch (err) {
      setError(getApiErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="call-center-page">
      <h1 className="call-center-title">Change Number</h1>
      <p className="call-center-subtitle">Replace an allocated number with another number.</p>

      <form className="call-center-card" onSubmit={onSubmit}>
        <div className="call-center-grid">
          <label className="call-center-field">
            Current Number
            <input
              type="text"
              value={currentPhoneNumber}
              onChange={(e) => setCurrentPhoneNumber(e.target.value)}
              placeholder="e.g. +61212345678"
              required
            />
          </label>

          <label className="call-center-field">
            New Number
            <input
              type="text"
              value={newPhoneNumber}
              onChange={(e) => setNewPhoneNumber(e.target.value)}
              placeholder="e.g. +61287654321"
              required
            />
          </label>

          <label className="call-center-field">
            Reason
            <input
              type="text"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Operational reason"
            />
          </label>
        </div>

        <div className="call-center-actions">
          <button className="call-center-btn" type="submit" disabled={submitting}>
            {submitting ? 'Submitting...' : 'Submit Change Request'}
          </button>
        </div>

        {error && <div className="call-center-message call-center-message-error">{error}</div>}
        {success && <div className="call-center-message call-center-message-success">{success}</div>}
      </form>
    </div>
  );
}
